import React from 'react';
import HeroSection from './components/Hero/HeroSection';
import './App.css';

function App() {
  return (
    <div className="App">
      <HeroSection />

      {/* Closing section — gives the scroll a destination after the last clip */}
      <section className="outro">
        <div className="outro__inner">
          <div className="outro__eyebrow-wrap">
            <span className="outro__dot" aria-hidden="true" />
            <span className="outro__eyebrow">CLEAN&nbsp;ENERGY&nbsp;&nbsp;·&nbsp;&nbsp;FULL&nbsp;CIRCLE</span>
          </div>
          <h2 className="outro__title">From Sun to Street</h2>
          <p className="outro__sub">
            Rooftop solar feeds the grid. The grid powers the charging network.
            The network powers your ride. Clean energy in a closed loop — from
            sunlight, to the wall, to the open road.
          </p>
          <button className="outro__cta" type="button">
            <span>Reserve Now</span>
            <span className="outro__cta-arrow" aria-hidden="true">→</span>
          </button>
        </div>
      </section>
    </div>
  );
}

export default App;
